import g from './utils/globalVariables.es6';
import getTargetElement from './utils/getTargetElement.es6';

const DROPDOWN_NAV_COLLAPSE_SELECTOR = '.js-dropdown-nav button[data-toggle="collapse"]';

const init = () => {
  g.$document
    .off('.dropdownNav')
    .on('click.dropdownNav', DROPDOWN_NAV_COLLAPSE_SELECTOR, toggleCollapseNav);
};
const toggleCollapseNav = (event) => {
  event.stopPropagation();
  event.preventDefault();

  let $trigger = $(event.currentTarget);
  let $target = getTargetElement($trigger);

  if ($target.length === 0) {
    return false;
  }

  $target.collapse('toggle');
};

export default init;
